import  { useRef, useState, useEffect } from 'react';
import image from "../../images/Interviews.png"
import image1 from "../../images/Interviews (1).png"
import image2 from "../../images/Interviews (2).png"
import image3 from "../../images/Interviews (3).png"
const InterviewsBlogs = () => {
  const scrollContainerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  // Sample interview data
  const interviews = [
    {
      id: 1,
      badge: "Closecarbon Chronicles ",
      title: "Smart energy grids: reshaping urban carbon footprints",
      description: "Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...",
      source: "2/11/2024",
      image: image,
      imagePosition: "55% 30%",
      type: "standard"
    },
    {
      id: 2,
      badge: "Closecarbon Chronicles ",
      title: "Low-carbon hydrogen: The next frontier for heavy industry",
      description: "Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...",
      source: "2/11/2024",
      image: image3,
      imagePosition: "center 30%",
      type: "standard"
    },
    {
      id: 3,
      badge: "Closecarbon Chronicles ",
      title: "Circular economy: Rethinking supply chains for net-zero",
      description: "Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...",
      source: "2/11/2024",
      image: image2,
      imagePosition: "top 30% center",
      type: "standard"
    },
    // {
    //   id: 4,
    //   badge: null,
    //   date: "Closecarbon Chronicles : 02 November 2024",
    //   title: "Sustainability Expert Q&A",
    //   description: "Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...",
    //   readMoreText: "Read Blog",
    //   image: image1,
    //   imagePosition: "50% 30%",
    //   type: "featured"
    // },
    // {
    //   id: 5,
    //   badge: "Carbon Removal Alliance",
    //   title: "Direct air capture: costs, scalability and policy levers",
    //   description: "Leading scientists break down the latest DAC innovations, funding mechanisms, and the role of carbon credits in accelerating deployment.",
    //   source: "MIT Climate Portal",
    //   image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800&h=600&fit=crop",
    //   imagePosition: "center",
    //   type: "standard"
    // }
  ];

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollAmount = 403; // Card width (379px) + gap (24px)
      const newScrollLeft = direction === 'left' 
        ? container.scrollLeft - scrollAmount 
        : container.scrollLeft + scrollAmount;
      
      container.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }
  };

  const checkScrollButtons = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const maxScroll = container.scrollWidth - container.clientWidth;
      setShowLeftArrow(container.scrollLeft > 0);
      setShowRightArrow(container.scrollLeft < maxScroll - 5);
    }
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener('scroll', checkScrollButtons);
      checkScrollButtons();
      return () => container.removeEventListener('scroll', checkScrollButtons);
    }
  }, []);

  const StandardCard = ({ data }) => (
    <div className="relative w-[379px] h-[532px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-xl flex flex-col items-center pb-2 mb-20 shrink-0">
      {/* Image Container */}
      <div className="relative w-full h-[282px] rounded-t-xl overflow-hidden">
        <img 
          src={data.image}
          alt={data.title}
          className="w-full h-full object-contain rounded-t-xl"
 
        />
      </div>
      
      {/* Article Content */}
      <div className="flex flex-col items-start gap-4 w-[352px] mt-0">
        {/* Badge */}
        <div className="bg-[#004617] mt-5 rounded px-1.5 py-0.5 h-[25px] flex items-center">
          <span className="text-white  font-medium text-[14px] leading-[21px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.badge}
          </span>
        </div>
        
        {/* Text Container */}
        <div className="flex flex-col items-start gap-3 w-full">
          <h3 className="text-[#141414] font-semibold text-[14px] leading-[26px] w-full" style={{ fontFeatureSettings: "'cv03' on, 'cv04' on, 'cv01' on" }}>
            {data.title}
          </h3>
          <p className="text-[#898989] font-normal text[14px] leading-[20px] w-full">
            {data.description}
          </p>
        </div>
        
        {/* Footer */}
        <div className="flex flex-row justify-between items-center w-full">
          <span className="text-[#3B3B3B] font-normal text-[14px] leading-[21px]">{data.source}</span>
          <div className="flex flex-row items-center gap-2 cursor-pointer group transition-all duration-150 hover:opacity-80">
            <span className="text-[#006633] font-medium text-[14px] leading-[20px]">Read More</span>
            <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 1L6.5 6L1.5 11" stroke="#006633" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );

  const FeaturedCard = ({ data }) => (
    <div className="relative w-[379px] h-[532px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-xl flex flex-col items-start overflow-hidden shrink-0">
      {/* Image Container */}
      <div className="relative w-full h-[302px] rounded-t-xl overflow-hidden">
        <div 
          className="absolute w-full h-full bg-cover bg-no-repeat"
          style={{ 
            backgroundImage: `url(${data.image})`,
            backgroundPosition: data.imagePosition,
            transform: 'scale(1.1)'
          }}
        />
      </div>
      
      {/* Text Content */}
      <div className="flex flex-col items-start gap-2 w-full px-4 py-4">
        <div className="text-[#0D924F] text-sm font-medium leading-[17px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
          {data.date}
        </div>
        <div className="flex flex-col items-start gap-2 w-full">
          <h3 className="text-[#141414] font-bold text-2xl leading-[29px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.title}
          </h3>
          <div className="flex flex-col gap-1 w-full">
            <p className="text-[#3B3B3B] text-base leading-[22px] w-full">
              {data.description}
            </p>
            <div className="flex flex-row items-center justify-start gap-1 mt-1 cursor-pointer group">
              <span className="text-[#0D924F] font-medium text-base leading-[19px]">{data.readMoreText}</span>
              <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 6H15M15 6L10 1M15 6L10 11" stroke="#0D924F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col items-start gap-10 w-full max-w-[1313px] h-auto md:h-[620px] ml-60">
      {/* Header Section */}
      <div className="flex flex-row justify-between items-start w-full max-w-[1200px] h-12 gap-10">
        <h2 className="text-[#0D924F] font-bold text-4xl leading-[43px] w-[171px] h-[43px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
          Interviews
        </h2>
        
        {/* Navigation Arrows */}
        <div className="flex flex-row items-start gap-6 w-[120px] h-12">
          <button 
            onClick={() => scroll('left')}
            className={`relative w-12 h-12 bg-[#F5F5F5] rounded-full flex items-center justify-center transition-all duration-200 hover:bg-gray-200 focus:ring-1 focus:ring-[#0D924F] ${!showLeftArrow ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            aria-label="Previous slide"
            disabled={!showLeftArrow}
          >
            <span className="inline-block w-2 h-2 border-l-2 border-b-2 border-[#CDDAD3] transform rotate-45 ml-1"></span>
          </button>
          
          <button 
            onClick={() => scroll('right')}
            className={`relative w-12 h-12 bg-[#F5F5F5] rounded-full flex items-center justify-center transition-all duration-200 hover:bg-gray-200 focus:ring-1 focus:ring-[#0D924F] ${!showRightArrow ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            aria-label="Next slide"
            disabled={!showRightArrow}
          >
            <span className="inline-block w-2 h-2 border-r-2 border-t-2 border-[#3B3B3B] transform rotate-45 mr-1"></span>
          </button>
        </div>
      </div>

      {/* Scrollable Carousel */}
      <div 
        ref={scrollContainerRef}
        className="relative w-full overflow-x-auto scroll-smooth rounded-xl no-scrollbar"
        style={{ scrollBehavior: 'smooth' }}
      >
        <div className="flex flex-row items-stretch gap-6 w-max">
          {interviews.map((interview) => (
            interview.type === 'featured' 
              ? <FeaturedCard key={interview.id} data={interview} />
              : <StandardCard key={interview.id} data={interview} />
          ))}
        </div>
      </div>

      <style jsx>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default InterviewsBlogs;